import Component from '../Component';
import SidePanelButton from './SidePanelButton';

class ControlButtonGroupLeft extends Component {
	constructor() {
		super();
		this.key = 'ctrl-btn-group-left';

		this.className = 'control-button-group--left';

		this.sidePanelButton = new SidePanelButton();
	}

	componentDidMount() {
		this.sidePanelButton.setRefs(this.refs);
		this.sidePanelButton.componentDidMount();
	}

	render() {
		return `
            ${this.sidePanelButton.render()}
        `;
	}
}

export default ControlButtonGroupLeft;
